import React from 'react'
import './footer.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faTiktok } from '@fortawesome/free-brands-svg-icons'

const Footer = () => {
  return (
    <div>
      <div className='footer'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-12 col-lg-8 col-xl-8 '>
              <form>
                <div className='input_form'>
                  <input
                    type='search'
                    placeholder='Put your Email to Subscribe'
                  />
                  <button type='submit'>Subscribe</button>
                </div>
              </form>

              <div className='copyright footer_content'>
                <h5>&copy; Copyright 2021</h5>
                <div className='weather_lite_footer'>
                  <a href='#'>
                    Weather<span className='active_tag1'>Lite.</span>
                  </a>
                </div>{' '}
              </div>
            </div>
            <div className='col-sm-12 col-md-12 col-lg-4 col-xl-4 icons'>
              <div className='footer_icon'>
                <FontAwesomeIcon icon={faFacebook} />
              </div>
              <div className='footer_icon'>
                <FontAwesomeIcon icon={faInstagram} />
              </div>
              <div className='footer_icon'>
                <FontAwesomeIcon icon={faTwitter} />
              </div>
              <div className='footer_icon'>
                <FontAwesomeIcon icon={faTiktok} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
